var map = {
	"./alert.gif": 43583,
	"./erun1.gif": 35492,
	"./erun2.gif": 90347,
	"./escratch1.gif": 15759,
	"./escratch2.gif": 26312,
	"./itch1.gif": 18214,
	"./itch2.gif": 37009,
	"./nerun1.gif": 32544,
	"./nerun2.gif": 25895,
	"./nrun1.gif": 12803,
	"./nrun2.gif": 46940,
	"./nscratch1.gif": 3376,
	"./nscratch2.gif": 94039,
	"./nwrun1.gif": 66822,
	"./nwrun2.gif": 85617,
	"./serun1.gif": 66847,
	"./serun2.gif": 56760,
	"./sleep1.gif": 40449,
	"./sleep2.gif": 92790,
	"./srun1.gif": 22974,
	"./srun2.gif": 78857,
	"./sscratch1.gif": 59945,
	"./sscratch2.gif": 78654,
	"./still.gif": 99751,
	"./swrun1.gif": 44305,
	"./swrun2.gif": 25510,
	"./wrun1.gif": 98682,
	"./wrun2.gif": 97365,
	"./wscratch1.gif": 64765,
	"./wscratch2.gif": 77282,
	"./yawn.gif": 19362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16998;